import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useMapStore } from '@/stores/mapStore';

export default function RiskZones() {
  const map = useMap();
  const riskZones = useMapStore((s) => s.riskZones);
  const layerRef = useRef<L.LayerGroup>(L.layerGroup());

  useEffect(() => {
    layerRef.current.addTo(map);
    return () => {
      layerRef.current.remove();
    };
  }, [map]);

  useEffect(() => {
    layerRef.current.clearLayers();

    riskZones.forEach((feature) => {
      const props = feature.properties;

      const geoJsonLayer = L.geoJSON(feature as unknown as GeoJSON.Feature, {
        style: {
          color: props.color || '#ef4444',
          weight: props.weight || 2,
          opacity: props.opacity || 0.6,
          fillColor: props.fillColor || props.color || '#ef4444',
          fillOpacity: props.fillOpacity || 0.15,
        },
        onEachFeature: (_f, layer) => {
          const zoneName = props.zone_name || props.name || 'Zona de riesgo';
          const riskLevel = props.risk_level || '';

          layer.bindTooltip(
            `<strong>${zoneName}</strong>${riskLevel ? `<br/>Riesgo: ${riskLevel}` : ''}`,
            { sticky: true }
          );

          layer.on('mouseover', () => {
            (layer as L.Path).setStyle({ fillOpacity: 0.35 });
          });
          layer.on('mouseout', () => {
            (layer as L.Path).setStyle({ fillOpacity: props.fillOpacity || 0.15 });
          });
        },
      });

      geoJsonLayer.addTo(layerRef.current);
    });
  }, [riskZones]);

  return null;
}
